import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError, checkBoxHelper, getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty, toBoolean } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { toNum } from '@shared/helpers/math.helper';
import { SCHEDA_ALLEGA_PATHS } from '../common/consts/scheda-allega-paths.const';
import { getCoopAltreCoopControl } from './helpers/coop-altre-coop-form.helpers';
import { formPaths } from '@shared/constants/form-paths.const';

export const schedaCoopAltreCoopRules: FormGroupRules = {
    my_AltreCoopNote: (form: FormGroup) => {
        requiredByScAltreCoopObbl(form, 'my_AltreCoopNote');
    },
    my_AltreCoopTipoScambioMutua: (form: FormGroup) => {
        requiredByScAltreCoopObbl(form, 'my_AltreCoopTipoScambioMutua');
    },

    my_AltreCoopAttivitaPrevalente: (form: FormGroup) => {
        const control = getCoopAltreCoopControl(form, 'my_AltreCoopAttivitaPrevalente');
        const ckSezAlboCorretta: string = getControl(form, 'my_SezioneI__Rilevazione.my_DatiIdentificativi.my_ckSezAlboCorretta').value;
        const scAltreCoopObbl: string = getCoopAltreCoopControl(form, 'my_ScAltreCoopObbl').value;
        const errors = control.errors ?? {};
        addRemoveError(isNilOrEmpty(control.value) && (scAltreCoopObbl === '1' || ckSezAlboCorretta === '0'), errors, 'my_AltreCoopAttivitaPrevalente', {
            status: REQUIRED_STATUS,
        });
        control.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_descNoSchedeCompilate: (form: FormGroup) => {
        const control = getCoopAltreCoopControl(form, 'my_descNoSchedeCompilate');
        const scAltreCoopObbl: string = getCoopAltreCoopControl(form, 'my_ScAltreCoopObbl').value;
        const errors = control.errors ?? {};
        const allUnchecked = SCHEDA_ALLEGA_PATHS.every((path) => !toBoolean(toNum(getCoopAltreCoopControl(form, path).value)));
        addRemoveError(isNilOrEmpty(control.value) && allUnchecked && scAltreCoopObbl === '1', errors, 'my_descNoSchedeCompilate', { status: REQUIRED_STATUS });
        control.setErrors(isEqual(errors, {}) ? null : errors);
    },
};

const requiredByScAltreCoopObbl = (form: FormGroup, targetPath: string): void => {
    checkBoxHelper(form, targetPath, 'my_ScAltreCoopObbl', 1, formPaths.schedaAltreCoop);
};

export const CoopAltreCoopFormValidators = Object.values(schedaCoopAltreCoopRules);
